export default "__VITE_ASSET__CUd01RWI__"